module.exports = __webpack_public_path__ + "media/site_templates/www.furnituremovingservices.com.au/images/about_us-bbde8a73da81a587014c7c9e534bf82b.jpg";